import Logo from './ui/Logo';
import Icon, { GithubIcon, LinkedinIcon } from './ui/Icon';
import { navLinks, site } from '../data/content';

const Footer = () => (
  <footer className="border-t border-white/[0.06] bg-ink-950">
    <div className="container-page py-14">
      <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <a href="#top" aria-label="KBL Web Solutions, back to top" className="inline-block">
            <Logo />
          </a>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-muted">
            Modern websites, custom web applications and AI-powered solutions for growing businesses in the San
            Francisco Bay Area and beyond.
          </p>
        </div>

        <nav aria-label="Footer">
          <p className="font-mono text-xs uppercase tracking-[0.16em] text-subtle">Explore</p>
          <ul className="mt-4 space-y-3 text-sm">
            {navLinks.map(({ label, id }) => (
              <li key={id}>
                <a href={`#${id}`} className="text-muted transition-colors hover:text-fg">
                  {label}
                </a>
              </li>
            ))}
            <li>
              <a href="#contact" className="text-muted transition-colors hover:text-fg">
                Contact
              </a>
            </li>
          </ul>
        </nav>

        <div>
          <p className="font-mono text-xs uppercase tracking-[0.16em] text-subtle">Get in touch</p>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a href={`mailto:${site.email}`} className="inline-flex items-center gap-2 text-muted transition-colors hover:text-fg">
                <Icon name="Mail" className="h-4 w-4" />
                {site.email}
              </a>
            </li>
            <li>
              <a
                href={site.github}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-muted transition-colors hover:text-fg"
              >
                <GithubIcon className="h-4 w-4" />
                GitHub
                <span className="sr-only">(opens in a new tab)</span>
              </a>
            </li>
            <li>
              <a
                href={site.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-muted transition-colors hover:text-fg"
              >
                <LinkedinIcon className="h-4 w-4" />
                LinkedIn
                <span className="sr-only">(opens in a new tab)</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-2 border-t border-white/[0.06] pt-6 text-xs text-subtle sm:flex-row sm:items-center sm:justify-between">
        <p>
          © {new Date().getFullYear()} {site.name}. All rights reserved.
        </p>
        <p>{site.location}</p>
      </div>
    </div>
  </footer>
);

export default Footer;
